import * as React from 'react';
import {AuthWrapper, CreateFormFlex, CreateFormWrapper} from "./share/auth_share_components";
import ParagraphSup from "../../common/atom/text/paragraph_sup";
import AuthApplyClientRegisterForm from "./apply_client_register/auth_apply_client_register_form";
import AuthApplyClientRegisterSide from "./apply_client_register/auth_apply_client_register_side";

interface IProps {
    handleApplyClient: (values: any) => void;
}

const AuthApplyClientRegisterComponent: React.FC<IProps> = (props) => {
    const {handleApplyClient} = props;

    return (
        <React.Fragment>
            <AuthWrapper>
                <CreateFormWrapper>
                    <CreateFormFlex>
                        <AuthApplyClientRegisterSide/>
                        <AuthApplyClientRegisterForm onSubmit={handleApplyClient}/>
                    </CreateFormFlex>
                    <ParagraphSup>© Libera Inc.</ParagraphSup>
                </CreateFormWrapper>
            </AuthWrapper>
        </React.Fragment>
    )

};

export default AuthApplyClientRegisterComponent;




// WEBPACK FOOTER //
// ./src/presentation/component/auth/auth_apply_client_register.tsx